import React from 'react';
// Constants
import { CONTACT_PAGE_URL, GALLERY_PAGE_URL } from '../../utils/Routes';
// Components
import WhatIOfferComponent from './WhatIOfferComponent';
import InformationSection from '../general/InformationSection';
// Images
import RealImage from '../../assets/images/noBackground/mistress-sammmi-smith-gorgeous-smoking-small.png';
import DungeonImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-with-whip.png';
import OnlineImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-full-body-small.png';
import FilmingImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-with-sub-on-cross.png';
import LastImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-ass-facing-camera-small.png';

function ServicesPageMainContainer() {
  return (
    <main role='main' className='grid w-full h-full overflow-hidden pb-12'>
      <div className='grid gap-8'>
        {/* Real Time */}
        <InformationSection
          sectionImage={RealImage}
          title={'Real Time Sessions'}
          orientation={true}
        >
          <div className='grid lg:text-lg'>
            <p>
              <strong>Come and experience</strong> my dominance in person. When
              you step into my world, you’ll feel the weight of my presence
              immediately. Whether you need strict discipline, sensual teasing,
              or complete submission, I will take control and guide you through
              an experience tailored to your desires. Kneel before me, obey my
              every command, and let me decide how far you’ll go.
            </p>
            <div className='mt-4 lg:mt-0'>
              <a
                href={CONTACT_PAGE_URL}
                className='blinking-button active:scale-90'
              >
                Book a Session
              </a>
            </div>
          </div>
        </InformationSection>

        {/* Dungeon */}
        <InformationSection
          sectionImage={DungeonImage}
          title={'Dungeon Experiences'}
          orientation={false}
        >
          <div className='grid lg:text-lg'>
            <p>
              Welcome to my <strong>private dungeon</strong> — a place where
              fantasies become reality. Here, I have all the tools and toys to
              test your limits, whether you're craving restraint, discipline, or
              exquisite suffering. The setting is dark, the energy intoxicating,
              and once you're in my hands, there is no escape. You will serve,
              worship, and endure—exactly as I desire.
            </p>
            <div className='lg:justify-end lg:flex mt-4 lg:mt-0 h-fit'>
              <a
                href={GALLERY_PAGE_URL}
                className='blinking-button active:scale-90'
              >
                See More
              </a>
            </div>
          </div>
        </InformationSection>

        {/* Online */}
        <InformationSection
          sectionImage={OnlineImage}
          title={'Online Domination'}
          orientation={true}
        >
          <div className='grid lg:text-lg'>
            <p>
              <strong>You don’t</strong> need to be in my physical presence to
              feel my control. My online sessions are just as intense, whether
              through video, voice, or text. I will train you, tease you, and
              push your boundaries no matter where you are in the world. From
              strict tasks to mind games, you’ll learn that my power extends far
              beyond the screen.
            </p>
            <div className='mt-4 lg:mt-0'>
              <a
                href={CONTACT_PAGE_URL}
                className='blinking-button active:scale-90'
              >
                Book a Session
              </a>
            </div>
          </div>
        </InformationSection>

        {/* Filming */}
        <InformationSection
          sectionImage={FilmingImage}
          title={'Filming Sessions'}
          orientation={false}
        >
          <div className='grid lg:text-lg'>
            <p>
              Do you want to be <strong>humiliated on camera?</strong> Or
              perhaps you dream of starring in an intense, unforgettable
              session? My filming experiences allow you to capture your
              submission under my command. Whether for private use or content
              creation, I will craft the perfect scene—sensual, punishing, or
              anything in between.
            </p>
            <div className='lg:justify-end lg:flex mt-4 lg:mt-0 h-fit'>
              <a
                href={CONTACT_PAGE_URL}
                className='blinking-button active:scale-90'
              >
                Book a Session
              </a>
            </div>
          </div>
        </InformationSection>

        {/* Fetishes */}
        <InformationSection
          sectionImage={LastImage}
          title={'Fetish Exploration'}
          orientation={true}
        >
          <div className='grid lg:text-lg'>
            <p>
              I <strong>know</strong> exactly what you crave. Foot worship,
              impact play, chastity, sensory deprivation—your desires fuel my
              amusement. Tell me your deepest fantasies, and I might indulge
              them… if you prove yourself worthy. Whether you need to be teased,
              tortured, or completely controlled, I will create an experience
              that leaves you aching for more.
            </p>
            <div className='mt-4 lg:mt-0'>
              <a
                href='#fetish-list'
                className='blinking-button active:scale-90'
              >
                Find Your Fetish
              </a>
            </div>
          </div>
        </InformationSection>

        {/* List of services */}
        <div className='mt-10'>
          <WhatIOfferComponent />
        </div>
      </div>
    </main>
  );
}

export default ServicesPageMainContainer;
